// assets/ja-klaviyo-badge-click.js

// Klaviyo review stars inside accordion fix.
// Opens review accordion and scrolls to it when stars are clicked.
// Uses capture phase because Klaviyo stops event propagation.

document.addEventListener('click', function (e) {

      const starWidget = e.target.closest('.klaviyo-star-rating-widget');
      if (!starWidget) return;

      const reviewTab = document.querySelector('.js-review-tab');
      if (!reviewTab) return;

      const reviewDetails = reviewTab.closest('details');
      if (!reviewDetails) return;

      e.preventDefault();
      e.stopImmediatePropagation();

      if (!reviewDetails.open) {
        reviewDetails.open = true;
      }

      setTimeout(function () {
        reviewDetails.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        });
      }, 120);

}, true);